import Vue from 'vue'
import VueI18n from 'vue-i18n'

import * as CONST from './const/shared'

import dateTimeFormats from './locales/dateTimeFormats'

Vue.use(VueI18n)

const fallbackLocale = process.env.VUE_APP_I18N_FALLBACK_LOCALE || CONST.languageFallback.locale

const currentSite = () => {
  // exact match first - production
  if (window.location.hostname === 'booking.essilor.com') {
    return CONST.sites.essilor
  } else if (window.location.hostname === 'booking.galileoitalia.it') {
    return CONST.sites.galileo
  } else if (window.location.hostname === 'booking.nikonlenswear.it') {
    return CONST.sites['nikon-it']
  }

  // regex match on first subdomain - fallback to essilor
  if (/^nikon-it\./.test(window.location.hostname)) {
    return CONST.sites['nikon-it']
  }
  if (/^galileo\./.test(window.location.hostname)) {
    return CONST.sites.galileo
  }
  return CONST.sites.essilor
}

const messages = new Map()
for (const site of Object.values(CONST.sites)) {
  messages.set(site, {})
  for (const lang of CONST.languages.filter(lang => Boolean(CONST.siteData[site].countries[lang.country]))) {
    try {
      const locale = require(`./locales/${site}/${lang.locale}`)
      locale.$vuetify = require(`vuetify/es5/locale/${lang.vuetify}`)
      messages.get(site)[lang.locale] = locale
    } catch (e) {
      console.warn(`[warning] Could not load locale ${site}/${lang.locale}`)
    }
  }

  try {
    // Include fallbackLocale if not exist
    if (!messages.get(site)[fallbackLocale]) {
      messages.get(site)[fallbackLocale] = require(`./locales/${site}/${fallbackLocale}`)
    }
  } catch (e) {
    console.warn(`[warning] Could not load fallback default locale ${site}/${fallbackLocale}`)
  }
}

export const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || CONST.languageFallback.locale,
  fallbackLocale,
  get messages() {
    return messages.get(currentSite())
  },
  dateTimeFormats
})

export { currentSite }
